var MailProvider;
(function (MailProvider) {
    MailProvider["default"] = "default";
    MailProvider["sendgrid"] = "sendgrid";
    MailProvider["mailbaby"] = "mailbaby";
})(MailProvider || (MailProvider = {}));
var MailDeliveryState;
(function (MailDeliveryState) {
    MailDeliveryState["success"] = "success";
    MailDeliveryState["failed"] = "failed";
    MailDeliveryState["waiting"] = "waiting";
})(MailDeliveryState || (MailDeliveryState = {}));
const toMailAddress = (data) => {
    return {
        name: data.name ?? '',
        email: data.email ?? ''
    };
};
const toMail = (data) => {
    return {
        id: data.id ?? '',
        to: Array.isArray(data.to) ? data.to.map(toMailAddress) : [],
        from: toMailAddress(data.from ?? {}),
        replyto: toMailAddress(data.replyto ?? {}),
        subject: data.subject ?? 'NA',
        body: data.body ?? 'NA',
        siteId: data.siteId ?? '',
        provider: data.provider ?? MailProvider.default,
        state: data.state ?? MailDeliveryState.waiting,
        lastUpdated: data.lastUpdated ?? '',
        delivery: Array.isArray(data.delivery)
            ? data.delivery.map((d) => ({
                to: toMailAddress(d.to ?? {}),
                from: toMailAddress(d.from ?? {}),
                replyto: toMailAddress(d.replyto ?? {}),
                provider: d.provider ?? MailProvider.default,
                error: d.error ?? '',
                info: d.info ?? {},
                time: d.time ?? '',
                state: d.state ??
                    MailDeliveryState.waiting
            }))
            : [],
        retryCount: data.retryCount ?? 0,
        createdAt: data.createdAt ?? data.lastUpdated ?? ''
    };
};
export { MailProvider, MailDeliveryState };
export { toMail, toMailAddress };
//# sourceMappingURL=mail.js.map